import { loginRegisterReducer } from "../ducks/loginRegister";
import { accountReducer } from "../ducks/account";
import { sideNavReducer } from "../ducks/sideNav";
import { forgotPasswordReducer } from "../ducks/forgotPassword";
import { newsletterReducer } from "../ducks/newsletter";
import { userReducer } from "../ducks/user";
import { entitlementsReducer } from "../ducks/entitlements";
import { subscriptionFormReducer } from "../ducks/subscriptionForm";
import { bulkSubscriptionFormReducer } from "../ducks/bulkSubscriptionForm";
import config from "./config";
import { thinkingReducer } from "../ducks/thinking";
import { manageSubscriptionReducer } from "../ducks/manageSubscription";
import { manageBulkSubscriptionReducer } from "../ducks/manageBulkSubscription";
import { paymentFormReducer } from "../ducks/paymentForm";
import { billingAddressFormReducer } from "../ducks/billingAddressForm";
import { shippingAddressFormReducer } from "../ducks/shippingAddressForm";
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { countryReducer } from "../ducks/country";
import { abbaReducer } from "../ducks/abba";
import { offerReducer } from "../ducks/offer";
import { counterOffersReducer } from "../ducks/counterOffers";
import { saveOfferReducer } from "../ducks/saveOffers";
import { studentFormReducer } from "../ducks/studentForm";
import { marketingReducer } from "../ducks/marketing";
import { onboardingReducer } from "../ducks/onboarding";

const rootReducer = combineReducers({
    abba: abbaReducer,
    account: accountReducer,
    billingAddressForm: billingAddressFormReducer,
    bulkSubscriptionForm: bulkSubscriptionFormReducer,
    config,
    counterOffers: counterOffersReducer,
    country: countryReducer,
    entitlements: entitlementsReducer,
    forgotPassword: forgotPasswordReducer,
    loginRegister: loginRegisterReducer,
    manageBulkSubscription: manageBulkSubscriptionReducer,
    manageSubscription: manageSubscriptionReducer,
    newsletter: newsletterReducer,
    offer: offerReducer,
    onboarding: onboardingReducer,
    paymentForm: paymentFormReducer,
    routing: routerReducer,
    saveOffers: saveOfferReducer,
    shippingAddressForm: shippingAddressFormReducer,
    sideNav: sideNavReducer,
    studentForm: studentFormReducer,
    subscriptionForm: subscriptionFormReducer,
    thinking: thinkingReducer,
    user: userReducer,
    marketing: marketingReducer
});

export default rootReducer;
